import { all, put, takeEvery } from 'redux-saga/effects'
import { LOCATION_CHANGE } from 'connected-react-router'
import _ from 'lodash'

import config from '@config'

import { AUTOLOGIN_ROUTE } from '../../routing/constants'

import { setActiveModule } from '../../routing/actions'
import { openReportById } from '../../../scenes/Gnosus/scenes/Report/actions'
import { openPortfolioById } from '../../../scenes/Gnosus/scenes/Portfolio/actions'

import { SOCKET_ACTION_TYPE, SOCKET_ON_MESSAGE } from '../constants'
import { sendMessage } from '../helpers'

import { WS_CHANGE_MODULE_TAB, WS_OPEN_REPORT, WS_OPEN_PORTFOLIO } from './constants'

function* onActiveModule(_action) {
    const rootPath = _.first(_.drop(_.split(_action.payload.location.pathname, /[/\?]/g))) // eslint-disable-line no-useless-escape

    if (rootPath !== AUTOLOGIN_ROUTE) {
        yield sendMessage(SOCKET_ACTION_TYPE.CHANGE_MODULE, { module: rootPath })
    }

    return null
}

function* onMessageFromOld(_action) {
    const type = _.get(_action, 'data.type', null)

    if (type === WS_CHANGE_MODULE_TAB) {
        const module = _.get(_action, 'data.content.moduleType', null)
        const entId = _.get(_action, 'data.content.data.entId', null)

        if (!_.isNil(entId)) {
            if (module === config.modules.report.key) yield put(openReportById(_.toString(entId)))
        }

        yield put(setActiveModule(module))
        return null
    }

    if (type === WS_OPEN_REPORT) {
        const entId = _.get(_action, 'data.content.entId', null)

        yield put(openReportById(_.toString(entId)))
        return null
    }

    if (type === WS_OPEN_PORTFOLIO) {
        const entId = _.get(_action, 'data.content.entId', null)

        yield put(openPortfolioById(_.toString(entId)))
        return null
    }

    return null
}

export default function* entityStackTabSaga() {
    yield all([takeEvery(SOCKET_ON_MESSAGE, onMessageFromOld), takeEvery(LOCATION_CHANGE, onActiveModule)])
}
